import allImgPaths from "assets/images";
import DonutChart from "components/common/charts/DonutChart";
import AttendeeListModal from "components/common/modal/AttendeeListModal";
import PinModal from "components/common/modal/PinModal";
import ViewContentModal from "components/common/modal/ViewContentModel";
import useAppState from "context/useAppState";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { updateRAGMessage } from "services/chat";
import { downloadData, sendEmails } from "services/event";
import { EMAIL_CATEGORIES, EMAIL_TEMPLATE_CATEGORIES } from "utils/constant";
import saveAs from 'file-saver';
import Toast from "components/common/Toast";

const EmailTemplateCard = ({ taskId, data: dataObj, deleteItem, editItem, actions, setEditorItemIsFavorite, unPinTaskData, callFromBoard }: any) => {
    const [data, setData] = useState(dataObj || null);
    const { id: eventId } = useParams();
    const [showPinModal, setShowPinModal] = useState(false);
    const [showOption, setShowOption] = useState<any>(false);
    const [isPinned, setIsPinned] = useState<boolean>(dataObj?.is_pinned || false)
    const [showViewModal, setShowViewModal] = useState(false);
    const [showListModal, setShowListModal] = useState(false);

    const handleUserImageError = (e: any) => {
        e.target.src = allImgPaths.defaultProfileImage
    }

    const deleteOne = (messageId: any, title: any) => {
        deleteItem({ messageId, taskId }, title)
        setShowOption(false)
    }

    const editOne = (messageId: any, title: any) => {
        editItem({ messageId, taskId }, title)
        setShowOption(false)
    }

    const sendEmail = async (ragId: any) => {
        // await sendEmails(eventId, { ragId })
        setShowListModal(true)
        setShowOption(false)
    }

    const openPinModal = async () => {
        setShowPinModal(true)
    }

    const afterSave = (value: boolean) => {
        if (value) {
            setIsPinned(true)
        }
    }

    const unPinTask = async () => {
        if (callFromBoard) return

        const payload = {
            isPinned: false,
            pinData: null,
            taskTitle: data?.title || ''
        }

        unPinTaskData(data?.ragId, payload)
        setIsPinned(false)
    }

    const unPinTaskFromMenu = async () => {
        const payload = {
            isPinned: false,
            pinData: null,
            taskTitle: data?.title || ''
        }

        unPinTaskData(data?.ragId, payload)
        setData(null)
    }

    const viewItem = (data: any) => {
        setShowViewModal(true)
        setShowOption(false)
    }

    const download = async (payload: any) => {
        setShowOption(false)
        Toast.info('', 'Downloading file...');

        try {
            const downloadPayload = {
                event_id: eventId,
                type: {
                    list: 'content',
                    id: payload?.ragId,
                    template: 'isEmailContent'
                },
                rag_id: payload.ragId
            }
            const response = await downloadData(downloadPayload)
            
            if (response) {
                const filename = `${payload?.title || 'download'}.pdf`
                saveAs(response, filename);
            }
        } catch (error) {
            Toast.error('', 'Failed to download file')
            console.log({ downloadError: error })
        }
    }

    return (
        <>
            {
                showPinModal &&
                <PinModal
                    draftTitle={data?.title || ''}
                    data={data}
                    setShowPinModal={setShowPinModal}
                    afterSave={afterSave}
                />
            }
            {
                showViewModal &&
                <ViewContentModal
                    data={data}
                    setShowViewModal={setShowViewModal}
                    type='rfp'
                />
            }
            {
                showListModal &&
                <AttendeeListModal
                    data={data}
                    ids={{ eventId, ragId: dataObj.ragId }}
                    setShowListModal={setShowListModal}
                    type='attendee'
                    categoryData={{ category: EMAIL_CATEGORIES.ATTENDEE_INVITATION, template_category: EMAIL_TEMPLATE_CATEGORIES.EMAIL_TEMPLATE }}
                />
            }
            {
                data?.content && data?.content?.length &&
                <div className='border border-[#EAECF0] px-2 py-2 rounded-[10px] bg-[#fff] w-[280px] flex-shrink-0 hover:shadow-xl'>
                    <div className="relative">
                        {/* callfromboard Design */}
                        {
                            callFromBoard &&
                            <div className="rounded-tl-lg rounded-tr-lg border border-dashed border-[#EAECF0] pl-4 pt-1">
                                <h5 className="text-lg text-[#344054] truncate max-w-52 font-interMedium">
                                    {data?.pinData?.title || 'No Title'}
                                </h5>
                                <h6 className="text-sm text-[#344054] pb-2 truncate max-w-52">
                                    {data?.pinData?.selectedOption || 'No Subheading'}
                                </h6>
                            </div>
                        }
                        <div className='h-[190px] rounded-[10px] mb-2.5 group'>
                            <div className='flex items-center justify-between'>
                                {!isPinned &&
                                    <div onClick={openPinModal} className={`group-hover:flex hidden items-center gap-x-1.5 bg-[#1E0AF5] hover:bg-[#120693] py-1.5 px-3 rounded-lg text-[#fff] absolute top-2 right-2 cursor-pointer w-fit`}>
                                        <img src={allImgPaths.pinPushIcon} alt="" />
                                        <span>Pin it</span>
                                    </div>
                                }
                                {
                                    isPinned &&
                                    <div className={`absolute top-2 right-2 w-fit pinned-state`}>
                                        <img src={allImgPaths.pinnedStateIcon} alt="" />
                                    </div>
                                }
                                <img
                                    className={`${callFromBoard ? "rounded-bl-[10px] rounded-br-[10px] " : "rounded-[10px]"} w-full h-full object-cover mb-2`}
                                    src={data?.imageUrl ? data.imageUrl : allImgPaths.EmailTemplateImage}
                                    alt=''
                                />
                            </div>
                        </div>
                        {
                            !callFromBoard &&
                            <h5 title={data?.title} className={`mt-1.5 text-[#101828] font-interSemiBold text-[17px] line-clamp-2 max-w-72 px-0.5 mb-2 h-12`}>
                                {data?.title || 'No title'}
                            </h5>
                        }
                    </div>

                    <div className='flex items-center gap-x-2 justify-between border-t border-[#EAECF0] pt-2 pb-1'>
                        <div className='flex items-start gap-x-2'>
                            <img
                                className='w-6 h-6 rounded-full'
                                src={data.userProfileImage || allImgPaths.defaultProfileImage}
                                alt=''
                                onError={(e: any) => handleUserImageError(e)}
                            />
                            <div>
                                <p className='text-xs text-[#667085] pb-0.5'>{data.userName}</p>
                                <p className='text-xs text-[#667085]'>{data.updatedTime}</p>
                            </div>
                        </div>

                        <div className='flex items-center gap-x-4'>
                            <div className="relative group">
                                <img className={`cursor-pointer`} src={allImgPaths.threeVerticleDotsIcon} alt="" />
                                {/* card_optiond */}
                                <div className={`absolute -right-1 -bottom-[10px] w-[188px] rounded-lg shadow-customShadow9 bg-[#fff] pl-2.5 pr-2.5 pt-2.5 pb-3 z-20 border border-[#eee] group-hover:block hidden`}>
                                    {
                                        callFromBoard &&
                                        <div
                                            className="flex items-center gap-x-2 mb-2 last:mb-0 py-1.5 px-1 custom-group-hover cursor-pointer"
                                            onClick={() => sendEmail(data.ragId)}>
                                            <img
                                                className='w-5 h-5 group-hover-child'
                                                src={allImgPaths.sendIcon}
                                                alt=''
                                            />
                                            <span className="text-[#101828] text-base font-interMedium leading-none group-hover-child-text">
                                                Send Email
                                            </span>
                                        </div>
                                    }
                                    {
                                        actions?.showView &&
                                        <div
                                            className="flex items-center gap-x-2 mb-2 last:mb-0 py-1.5 px-1 custom-group-hover cursor-pointer"
                                            onClick={() => viewItem(data)}
                                        >
                                            <img
                                                className='w-5 h-5 group-hover-child'
                                                src={allImgPaths.iButtonIcon}
                                                alt=''
                                            />
                                            <span className="text-[#101828] text-base font-interMedium leading-none group-hover-child-text">
                                                View
                                            </span>
                                        </div>
                                    }
                                    {
                                        !isPinned && !callFromBoard &&
                                        <div className="flex items-center gap-x-2 mb-2 last:mb-0 py-1.5 px-1 custom-group-hover cursor-pointer" onClick={() => editOne(data?.messageId, data.title)}>
                                            <img
                                                className='w-5 h-5 group-hover-child'
                                                src={allImgPaths.EditIcon2}
                                                alt=''
                                            />
                                            <span className="text-[#101828] text-base font-interMedium leading-none group-hover-child-text">
                                                Edit
                                            </span>
                                        </div>
                                    }
                                    {
                                        !callFromBoard && actions?.showDelete && !isPinned &&
                                        <div
                                            className="flex items-center gap-x-2 mb-2 last:mb-0 py-1.5 px-1 custom-group-hover cursor-pointer"
                                            onClick={() => deleteOne(data?.messageId, data.title)}>
                                            <img
                                                className='w-5 h-5 group-hover-child'
                                                src={allImgPaths.deleteIcon4}
                                                alt=''
                                            />
                                            <span className="text-[#101828] text-base font-interMedium leading-none group-hover-child-text">
                                                Delete
                                            </span>
                                        </div>
                                    }
                                    {
                                        actions?.showDownload &&
                                        <div
                                            className="flex items-center gap-x-2 mb-2 last:mb-0 py-1.5 px-1 custom-group-hover cursor-pointer"
                                            onClick={() => download(data)}
                                        >
                                            <img
                                                className='w-5 h-5 group-hover-child'
                                                src={allImgPaths.downloadIcon2}
                                                alt=''
                                            />
                                            <span className="text-[#101828] text-base font-interMedium leading-none group-hover-child-text">
                                                Download
                                            </span>
                                        </div>
                                    }
                                    {
                                        callFromBoard &&
                                        <div
                                            className="flex items-center gap-x-1 last:mb-0 py-1.5 px-1 cursor-pointer custom-group-hover" onClick={unPinTaskFromMenu}>
                                            <img 
                                                className='w-5 h-5 group-hover-child'
                                                src={allImgPaths.deleteIcon4}
                                                alt=''
                                            />
                                            <span className="text-[#101828] text-base font-interMedium leading-none group-hover-child-text pl-1">
                                                Unpin
                                            </span>
                                        </div>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default EmailTemplateCard;
